import { render } from "./Dangers.vue?vue&type=template&id=46d682b3&scoped=true"
import script from "./Dangers.vue?vue&type=script&lang=js"
export * from "./Dangers.vue?vue&type=script&lang=js"

import "./Dangers.vue?vue&type=style&index=0&id=46d682b3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d682b3"]])

export default __exports__